import { render, staticRenderFns } from "./DeliveryEditStatus.vue?vue&type=template&id=2bcec56a&"
import script from "./DeliveryEditStatus.vue?vue&type=script&lang=js&"
export * from "./DeliveryEditStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports